<template>
    <div class="flex flex-col">
        <div class="min-h-18 flex gap-3 items-center">
            <hts-ui-tabs
                v-model="tapSelected"
                class="w-full"
                :tabs="tabs"
                color="main" />
            <hts-map-icon-location />
            <hts-map-icon-map class="pr-2" />
        </div>

        <div class="mx-2 h-full max-h-full overflow-y-auto">
            <alerts
                v-if="tapSelected === 'alerts'"
                :journey="journey" />
            <info-files
                v-if="tapSelected === 'document'"
                ref="tabFile"
                :journey-id="journey._id" />
        </div>
    </div>
</template>
<script setup lang="ts">
import InfoFiles from '../files.vue'
import alerts from './alerts.vue'

const props = defineProps({
  journey: {
    type: Object,
    required: true
  }
})

const { journey } = toRefs(props)

const tapSelected = ref('')
const tabs = ref([
  { key: 'alerts', label: $t('labels.alerts'), permission: true },
  { key: 'document', label: $t('labels.document'), permission: true }
])
</script>
